<template>
    <div class="time-progress" style="width: 100%;">
        <div class="d-flex align-center mb-2">
            <v-icon color="primary" small class="mr-1">mdi-timer</v-icon>
            <span class="font-weight-bold">Tempo</span>
            <v-spacer></v-spacer>
        </div>
        <div style="position: relative; width: 100%; height: 22px;">
            <div style="position: absolute; left: 0; top: 0; height: 18px; width: 100%; background: #e0e0e0; border-radius: 9px;"></div>
            <div :style="chargingStyle" class="success"></div>
            <div :style="idleStyle" class="warning"></div>
        </div>
        <div class="d-flex mt-1" style="font-size: 13px;">
            <div class="d-flex align-center flex-wrap" style="gap: 12px; justify-content: center;">
                <span class="success" style="display:inline-block;width:18px;height:10px;border-radius:3px;margin-right:4px;"></span> <strong>Carregando:</strong> {{ charging }}
                min
                <span class="warning" style="display:inline-block;width:18px;height:10px;border-radius:3px;margin-right:4px;"></span> <strong>Ocioso:</strong> {{ idle }} min
                <span style="display:inline-block;width:18px;height:10px;background:#e0e0e0;border-radius:3px;margin-right:4px;"></span> <strong>Total Conectado:</strong> {{
                connected }} min
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimeProgress',
    props: {
        charging: {
            type: Number,
            required: true
        },
        connected: {
            type: Number,
            required: true
        },
    },
    computed: {
        idle() {
            return Math.max(this.connected - this.charging, 0);
        },
        chargingStyle() {
            const percent = this.connected > 0 ? (this.charging / this.connected) * 100 : 0;
            return {
                position: 'absolute',
                left: 0,
                top: '0',
                height: '18px',
                width: percent + '%',
                borderRadius: '9px 0 0 9px',
                transition: 'all 0.3s',
                zIndex: 2
            };
        },
        idleStyle() {
            const percent = this.connected > 0 ? (this.idle / this.connected) * 100 : 0;
            const left = this.connected > 0 ? (this.charging / this.connected) * 100 : 0;
            return {
                position: 'absolute',
                left: left + '%',
                top: '0',
                height: '18px',
                width: percent + '%',
                borderRadius: left + percent >= 100 ? '0 9px 9px 0' : '0',
                transition: 'all 0.3s',
                zIndex: 2
            };
        }
    }
};
</script>
